/**
 * Theme Definitions
 * 테마 색상 팔레트 정의
 */

export const themes = {
  // ============================================
  // 기본 테마
  // ============================================
  default: {
    id: 'default',
    name: 'Modern Classic',
    description: '깔끔하고 세련된 기본 테마',
    colors: {
      // Primary colors
      primary: '#2c3e50',
      primaryHover: '#1a252f',
      secondary: '#3498db',
      secondaryHover: '#2980b9',

      // Background colors
      background: '#ffffff',
      backgroundAlt: '#f8fafc',
      backgroundDark: '#2c3e50',

      // Text colors
      text: '#2c3e50',
      textLight: '#ffffff',
      textMuted: '#7f8c8d',
      textSecondary: '#5d6d7e',

      // UI colors
      border: '#e1e8ed',
      borderLight: '#f1f5f8',
      shadow: 'rgba(44, 62, 80, 0.08)',
      shadowDark: 'rgba(44, 62, 80, 0.15)',

      // Status colors
      success: '#27ae60',
      warning: '#f39c12',
      danger: '#e74c3c',
      info: '#3498db',

      // Header/Footer specific
      headerBg: '#ffffff',
      headerText: '#2c3e50',
      footerBg: '#2c3e50',
      footerText: '#ffffff',
    },
  },

  // ============================================
  // 프리미엄 테마
  // ============================================
  navyGold: {
    id: 'navyGold',
    name: 'Navy & Gold',
    description: '고급스러운 네이비 & 골드',
    colors: {
      primary: '#1a2744',
      primaryHover: '#0f1a2e',
      secondary: '#c9a961',
      secondaryHover: '#b8954d',
      background: '#ffffff',
      backgroundAlt: '#f7f8fa',
      backgroundDark: '#1a2744',
      text: '#1a2744',
      textLight: '#ffffff',
      textMuted: '#6c757d',
      textSecondary: '#5a6a7a',
      border: '#e0e4e8',
      borderLight: '#f0f2f5',
      shadow: 'rgba(26, 39, 68, 0.1)',
      shadowDark: 'rgba(26, 39, 68, 0.2)',
      success: '#28a745',
      warning: '#c9a961',
      danger: '#dc3545',
      info: '#1a2744',
      headerBg: '#1a2744',
      headerText: '#ffffff',
      footerBg: '#1a2744',
      footerText: '#ffffff',
    },
  },

  burgundyGold: {
    id: 'burgundyGold',
    name: 'Burgundy & Gold',
    description: '와인 레드 & 골드 럭셔리',
    colors: {
      primary: '#722f37',
      primaryHover: '#5a252c',
      secondary: '#d4af37',
      secondaryHover: '#c9a227',
      background: '#ffffff',
      backgroundAlt: '#faf8f6',
      backgroundDark: '#722f37',
      text: '#3d2125',
      textLight: '#ffffff',
      textMuted: '#8b7355',
      textSecondary: '#6d5c4e',
      border: '#e8e0d8',
      borderLight: '#f5f0eb',
      shadow: 'rgba(114, 47, 55, 0.1)',
      shadowDark: 'rgba(114, 47, 55, 0.2)',
      success: '#5d8a48',
      warning: '#d4af37',
      danger: '#c44536',
      info: '#722f37',
      headerBg: '#722f37',
      headerText: '#ffffff',
      footerBg: '#722f37',
      footerText: '#ffffff',
    },
  },

  emeraldGold: {
    id: 'emeraldGold',
    name: 'Emerald & Gold',
    description: '에메랄드 & 골드 프리미엄',
    colors: {
      primary: '#0d5c4d',
      primaryHover: '#094439',
      secondary: '#d4a373',
      secondaryHover: '#c4935f',
      background: '#ffffff',
      backgroundAlt: '#f6faf9',
      backgroundDark: '#0d5c4d',
      text: '#1a3a32',
      textLight: '#ffffff',
      textMuted: '#6b8f84',
      textSecondary: '#4a7066',
      border: '#d4e5e0',
      borderLight: '#e8f2ef',
      shadow: 'rgba(13, 92, 77, 0.1)',
      shadowDark: 'rgba(13, 92, 77, 0.2)',
      success: '#2e8b57',
      warning: '#d4a373',
      danger: '#c75643',
      info: '#0d5c4d',
      headerBg: '#0d5c4d',
      headerText: '#ffffff',
      footerBg: '#0d5c4d',
      footerText: '#ffffff',
    },
  },

  // ============================================
  // 모던 & 트렌디 테마
  // ============================================
  oceanBreeze: {
    id: 'oceanBreeze',
    name: 'Ocean Breeze',
    description: '시원한 바다 느낌',
    colors: {
      primary: '#0077b6',
      primaryHover: '#005f92',
      secondary: '#00b4d8',
      secondaryHover: '#0096b4',
      background: '#ffffff',
      backgroundAlt: '#f0f9ff',
      backgroundDark: '#023e5a',
      text: '#023e5a',
      textLight: '#ffffff',
      textMuted: '#6b9dc2',
      textSecondary: '#4a7c9b',
      border: '#cae9ff',
      borderLight: '#e5f4ff',
      shadow: 'rgba(0, 119, 182, 0.1)',
      shadowDark: 'rgba(0, 119, 182, 0.2)',
      success: '#06d6a0',
      warning: '#ffd166',
      danger: '#ef476f',
      info: '#00b4d8',
      headerBg: '#0077b6',
      headerText: '#ffffff',
      footerBg: '#023e5a',
      footerText: '#ffffff',
    },
  },

  sunsetGlow: {
    id: 'sunsetGlow',
    name: 'Sunset Glow',
    description: '따뜻한 석양빛',
    colors: {
      primary: '#e85d04',
      primaryHover: '#c44d03',
      secondary: '#faa307',
      secondaryHover: '#dc9006',
      background: '#ffffff',
      backgroundAlt: '#fff8f0',
      backgroundDark: '#6a2c0a',
      text: '#4a2511',
      textLight: '#ffffff',
      textMuted: '#b87333',
      textSecondary: '#8b5a2b',
      border: '#fde4cf',
      borderLight: '#fef3e8',
      shadow: 'rgba(232, 93, 4, 0.1)',
      shadowDark: 'rgba(232, 93, 4, 0.2)',
      success: '#52b788',
      warning: '#faa307',
      danger: '#d62828',
      info: '#e85d04',
      headerBg: '#e85d04',
      headerText: '#ffffff',
      footerBg: '#6a2c0a',
      footerText: '#ffffff',
    },
  },

  roseGold: {
    id: 'roseGold',
    name: 'Rose Gold',
    description: '우아한 로즈 골드',
    colors: {
      primary: '#b76e79',
      primaryHover: '#9d5a64',
      secondary: '#e8c4b8',
      secondaryHover: '#d9b0a2',
      background: '#ffffff',
      backgroundAlt: '#fdf8f7',
      backgroundDark: '#5c3a3f',
      text: '#4a3033',
      textLight: '#ffffff',
      textMuted: '#a08080',
      textSecondary: '#7d5c5c',
      border: '#f0ddd8',
      borderLight: '#f8eeeb',
      shadow: 'rgba(183, 110, 121, 0.1)',
      shadowDark: 'rgba(183, 110, 121, 0.2)',
      success: '#6b9080',
      warning: '#d4a373',
      danger: '#c45b5b',
      info: '#b76e79',
      headerBg: '#b76e79',
      headerText: '#ffffff',
      footerBg: '#5c3a3f',
      footerText: '#ffffff',
    },
  },

  lavenderMist: {
    id: 'lavenderMist',
    name: 'Lavender Mist',
    description: '부드러운 라벤더',
    colors: {
      primary: '#7c3aed',
      primaryHover: '#6429c9',
      secondary: '#a78bfa',
      secondaryHover: '#8b6ce8',
      background: '#ffffff',
      backgroundAlt: '#faf8ff',
      backgroundDark: '#3b1d6e',
      text: '#2e1a47',
      textLight: '#ffffff',
      textMuted: '#9381a4',
      textSecondary: '#6b5b7a',
      border: '#e9e0f5',
      borderLight: '#f4f0fa',
      shadow: 'rgba(124, 58, 237, 0.1)',
      shadowDark: 'rgba(124, 58, 237, 0.2)',
      success: '#10b981',
      warning: '#f59e0b',
      danger: '#ef4444',
      info: '#7c3aed',
      headerBg: '#7c3aed',
      headerText: '#ffffff',
      footerBg: '#3b1d6e',
      footerText: '#ffffff',
    },
  },

  // ============================================
  // 자연 테마
  // ============================================
  forestGreen: {
    id: 'forestGreen',
    name: 'Forest Green',
    description: '자연 친화적 그린',
    colors: {
      primary: '#2d5a3d',
      primaryHover: '#1f4029',
      secondary: '#8fb996',
      secondaryHover: '#7aa882',
      background: '#ffffff',
      backgroundAlt: '#f5f9f6',
      backgroundDark: '#1a3324',
      text: '#1a3324',
      textLight: '#ffffff',
      textMuted: '#6b8f73',
      textSecondary: '#4a6b52',
      border: '#d4e5d8',
      borderLight: '#e8f2eb',
      shadow: 'rgba(45, 90, 61, 0.1)',
      shadowDark: 'rgba(45, 90, 61, 0.2)',
      success: '#4caf50',
      warning: '#c9a961',
      danger: '#c75643',
      info: '#2d5a3d',
      headerBg: '#2d5a3d',
      headerText: '#ffffff',
      footerBg: '#1a3324',
      footerText: '#ffffff',
    },
  },

  earthTone: {
    id: 'earthTone',
    name: 'Earth Tone',
    description: '따뜻한 어스톤',
    colors: {
      primary: '#8b6f4e',
      primaryHover: '#6f5a3f',
      secondary: '#c4a77d',
      secondaryHover: '#b39569',
      background: '#ffffff',
      backgroundAlt: '#faf8f5',
      backgroundDark: '#4a3c2e',
      text: '#3d3125',
      textLight: '#ffffff',
      textMuted: '#a08060',
      textSecondary: '#7a6548',
      border: '#e8dfd0',
      borderLight: '#f4efe6',
      shadow: 'rgba(139, 111, 78, 0.1)',
      shadowDark: 'rgba(139, 111, 78, 0.2)',
      success: '#6b8e23',
      warning: '#daa520',
      danger: '#b5651d',
      info: '#8b6f4e',
      headerBg: '#8b6f4e',
      headerText: '#ffffff',
      footerBg: '#4a3c2e',
      footerText: '#ffffff',
    },
  },

  cherryBlossom: {
    id: 'cherryBlossom',
    name: 'Cherry Blossom',
    description: '봄날의 벚꽃',
    colors: {
      primary: '#d4617f',
      primaryHover: '#bf4d6a',
      secondary: '#f8b4c4',
      secondaryHover: '#f09db0',
      background: '#ffffff',
      backgroundAlt: '#fef5f7',
      backgroundDark: '#5c2a3a',
      text: '#4a2030',
      textLight: '#ffffff',
      textMuted: '#b88898',
      textSecondary: '#8b6070',
      border: '#f8dce3',
      borderLight: '#fcecf0',
      shadow: 'rgba(212, 97, 127, 0.1)',
      shadowDark: 'rgba(212, 97, 127, 0.2)',
      success: '#7cb342',
      warning: '#ffb74d',
      danger: '#e57373',
      info: '#d4617f',
      headerBg: '#d4617f',
      headerText: '#ffffff',
      footerBg: '#5c2a3a',
      footerText: '#ffffff',
    },
  },

  // ============================================
  // 미니멀 & 모노톤 테마
  // ============================================
  slateGray: {
    id: 'slateGray',
    name: 'Slate Gray',
    description: '세련된 슬레이트 그레이',
    colors: {
      primary: '#475569',
      primaryHover: '#334155',
      secondary: '#94a3b8',
      secondaryHover: '#7c8ca0',
      background: '#ffffff',
      backgroundAlt: '#f8fafc',
      backgroundDark: '#1e293b',
      text: '#1e293b',
      textLight: '#ffffff',
      textMuted: '#94a3b8',
      textSecondary: '#64748b',
      border: '#e2e8f0',
      borderLight: '#f1f5f9',
      shadow: 'rgba(71, 85, 105, 0.1)',
      shadowDark: 'rgba(71, 85, 105, 0.2)',
      success: '#22c55e',
      warning: '#eab308',
      danger: '#ef4444',
      info: '#475569',
      headerBg: '#475569',
      headerText: '#ffffff',
      footerBg: '#1e293b',
      footerText: '#ffffff',
    },
  },

  pureBlack: {
    id: 'pureBlack',
    name: 'Pure Black',
    description: '모던 블랙 & 화이트',
    colors: {
      primary: '#171717',
      primaryHover: '#000000',
      secondary: '#525252',
      secondaryHover: '#404040',
      background: '#ffffff',
      backgroundAlt: '#fafafa',
      backgroundDark: '#171717',
      text: '#171717',
      textLight: '#ffffff',
      textMuted: '#a3a3a3',
      textSecondary: '#737373',
      border: '#e5e5e5',
      borderLight: '#f5f5f5',
      shadow: 'rgba(0, 0, 0, 0.08)',
      shadowDark: 'rgba(0, 0, 0, 0.15)',
      success: '#22c55e',
      warning: '#f59e0b',
      danger: '#ef4444',
      info: '#171717',
      headerBg: '#171717',
      headerText: '#ffffff',
      footerBg: '#171717',
      footerText: '#ffffff',
    },
  },

  // ============================================
  // 다크 테마
  // ============================================
  midnightBlue: {
    id: 'midnightBlue',
    name: 'Midnight Blue',
    description: '깊은 밤하늘',
    colors: {
      primary: '#1e3a5f',
      primaryHover: '#152a45',
      secondary: '#4a90d9',
      secondaryHover: '#3a7bc4',
      background: '#f0f4f8',
      backgroundAlt: '#e2e8f0',
      backgroundDark: '#0f1c2e',
      text: '#1e3a5f',
      textLight: '#ffffff',
      textMuted: '#6b8cae',
      textSecondary: '#4a6b8a',
      border: '#c8d6e5',
      borderLight: '#dce6f0',
      shadow: 'rgba(30, 58, 95, 0.1)',
      shadowDark: 'rgba(30, 58, 95, 0.2)',
      success: '#00b894',
      warning: '#fdcb6e',
      danger: '#ff7675',
      info: '#4a90d9',
      headerBg: '#1e3a5f',
      headerText: '#ffffff',
      footerBg: '#0f1c2e',
      footerText: '#ffffff',
    },
  },

  darkMode: {
    id: 'darkMode',
    name: 'Dark Mode',
    description: '눈이 편한 다크 모드',
    colors: {
      primary: '#60a5fa',
      primaryHover: '#3b82f6',
      secondary: '#a78bfa',
      secondaryHover: '#8b5cf6',
      background: '#1f2937',
      backgroundAlt: '#111827',
      backgroundDark: '#030712',
      text: '#f9fafb',
      textLight: '#f9fafb',
      textMuted: '#9ca3af',
      textSecondary: '#d1d5db',
      border: '#374151',
      borderLight: '#4b5563',
      shadow: 'rgba(0, 0, 0, 0.3)',
      shadowDark: 'rgba(0, 0, 0, 0.5)',
      success: '#34d399',
      warning: '#fbbf24',
      danger: '#f87171',
      info: '#60a5fa',
      headerBg: '#111827',
      headerText: '#f9fafb',
      footerBg: '#030712',
      footerText: '#f9fafb',
    },
  },

  // ============================================
  // 특별 테마
  // ============================================
  coralReef: {
    id: 'coralReef',
    name: 'Coral Reef',
    description: '생동감 있는 코랄',
    colors: {
      primary: '#ff6b6b',
      primaryHover: '#ee5a5a',
      secondary: '#4ecdc4',
      secondaryHover: '#3dbdb4',
      background: '#ffffff',
      backgroundAlt: '#fff5f5',
      backgroundDark: '#2c3e50',
      text: '#2c3e50',
      textLight: '#ffffff',
      textMuted: '#95a5a6',
      textSecondary: '#7f8c8d',
      border: '#fce4e4',
      borderLight: '#fef0f0',
      shadow: 'rgba(255, 107, 107, 0.1)',
      shadowDark: 'rgba(255, 107, 107, 0.2)',
      success: '#4ecdc4',
      warning: '#ffe66d',
      danger: '#ff6b6b',
      info: '#74b9ff',
      headerBg: '#ff6b6b',
      headerText: '#ffffff',
      footerBg: '#2c3e50',
      footerText: '#ffffff',
    },
  },

  royalPurple: {
    id: 'royalPurple',
    name: 'Royal Purple',
    description: '왕실의 보라',
    colors: {
      primary: '#5b2c6f',
      primaryHover: '#4a235a',
      secondary: '#9b59b6',
      secondaryHover: '#8e44ad',
      background: '#ffffff',
      backgroundAlt: '#f9f5fb',
      backgroundDark: '#2c1337',
      text: '#2c1337',
      textLight: '#ffffff',
      textMuted: '#9b7aa0',
      textSecondary: '#735880',
      border: '#e8d8ed',
      borderLight: '#f3ecf5',
      shadow: 'rgba(91, 44, 111, 0.1)',
      shadowDark: 'rgba(91, 44, 111, 0.2)',
      success: '#27ae60',
      warning: '#f39c12',
      danger: '#c0392b',
      info: '#9b59b6',
      headerBg: '#5b2c6f',
      headerText: '#ffffff',
      footerBg: '#2c1337',
      footerText: '#ffffff',
    },
  },

  tealCopper: {
    id: 'tealCopper',
    name: 'Teal & Copper',
    description: '틸 & 코퍼 조화',
    colors: {
      primary: '#008080',
      primaryHover: '#006666',
      secondary: '#b87333',
      secondaryHover: '#a06028',
      background: '#ffffff',
      backgroundAlt: '#f5fafa',
      backgroundDark: '#004040',
      text: '#1a3d3d',
      textLight: '#ffffff',
      textMuted: '#6d9898',
      textSecondary: '#4a7575',
      border: '#cce5e5',
      borderLight: '#e5f2f2',
      shadow: 'rgba(0, 128, 128, 0.1)',
      shadowDark: 'rgba(0, 128, 128, 0.2)',
      success: '#2ecc71',
      warning: '#b87333',
      danger: '#c0392b',
      info: '#008080',
      headerBg: '#008080',
      headerText: '#ffffff',
      footerBg: '#004040',
      footerText: '#ffffff',
    },
  },

  arcticBlue: {
    id: 'arcticBlue',
    name: 'Arctic Blue',
    description: '시원한 북극 블루',
    colors: {
      primary: '#5dacd4',
      primaryHover: '#4a9bc3',
      secondary: '#1b4965',
      secondaryHover: '#153a51',
      background: '#ffffff',
      backgroundAlt: '#f0f8fc',
      backgroundDark: '#1b4965',
      text: '#1b4965',
      textLight: '#ffffff',
      textMuted: '#7ba8c4',
      textSecondary: '#5085a5',
      border: '#cfe4ef',
      borderLight: '#e5f0f7',
      shadow: 'rgba(93, 172, 212, 0.1)',
      shadowDark: 'rgba(93, 172, 212, 0.2)',
      success: '#48c774',
      warning: '#ffdd57',
      danger: '#f14668',
      info: '#5dacd4',
      headerBg: '#1b4965',
      headerText: '#ffffff',
      footerBg: '#1b4965',
      footerText: '#ffffff',
    },
  },
};

export const defaultThemeId = 'default';

export const getThemeById = (themeId) => {
  return themes[themeId] || themes[defaultThemeId];
};

export const getAvailableThemesList = () => {
  return Object.values(themes).map(theme => ({
    id: theme.id,
    name: theme.name,
    description: theme.description,
    previewColor: theme.colors.primary,
    secondaryColor: theme.colors.secondary,
  }));
};
